import { Facebook, Instagram } from "lucide-react";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const scrollToSection = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <footer className="bg-foreground text-background py-12">
            <div className="container mx-auto px-4 md:px-8">
                <div className="grid md:grid-cols-3 gap-8 mb-8">
                    <div>
                        <h3 className="font-display text-2xl font-bold mb-4">
                            Bartkiewicz<span className="text-primary"> Meble</span>
                        </h3>
                        <p className="text-background/70 text-sm leading-relaxed">
                            Tworzymy meble na wymiar, które łączą funkcjonalność z eleganckim designem.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4">Szybkie linki</h4>
                        <ul className="space-y-2">
                            {[
                                { label: "O nas", id: "o-nas" },
                                { label: "Oferta", id: "oferta" },
                                { label: "Galeria", id: "galeria" },
                                { label: "Kontakt", id: "kontakt" },
                            ].map((link) => (
                                <li key={link.id}>
                                    <button
                                        onClick={() => scrollToSection(link.id)}
                                        className="text-background/70 hover:text-primary transition-colors text-sm"
                                    >
                                        {link.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4">Śledź nas</h4>
                        <div className="flex gap-4">
                            <a 
                                className="w-10 h-10 bg-background/10 rounded-full flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"
                                href="https://www.facebook.com/profile.php?id=61579719491527"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <Facebook className="w-5 h-5" />
                            </a>
                            <a 
                                className="w-10 h-10 bg-background/10 rounded-full flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors"
                                href="https://www.instagram.com/bartkiewicz_meble"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <Instagram className="w-5 h-5" />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="border-t border-background/10 pt-8 text-center text-background/50 text-sm">
                    <p>© {currentYear} Bartkiewicz Meble. Wszelkie prawa zastrzeżone.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;